import Vue from "vue";
import router from "src/control/main-router.js";
import store from "src/store/index"

// **********拦截器*********
let _instance;  //存axios封装对象
function getKeyUrl(config) {
    //获取关键url
    if (config === undefined) {
        return "";
    }
    return config.url.replace(config.baseURL, "").replace(/\d+$/, "");
}

// 下载功能
const downloadUrl = url => {
    let iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
    document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
}
  
// 推送消息
function pushInfo(response){
    // 包含特别字段才需要推消息
    let data = response.data.res_data && response.data.res_data.pushMsgInfo;
    if(data){
        console.log('触发推消息')
        _instance.post("api/websocket/msg/manage",{
            ...data
        })
        .then(res=>{
            console.log("推消息")
            console.log(res);
        });
    }
}

export default function(instance){
    _instance = instance;
    instance.interceptors.response.use(
        response => {
            // 下载文件
            if (response.headers && 
                (response.headers['content-type'] === 'application/x-msdownload' 
                || response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
                // || response.headers['content-type'] === 'application/octet-stream' 
            ) {
                console.log(response.request.responseURL)
                downloadUrl(response.request.responseURL)
                return
            }
    
            let keyUrl = getKeyUrl(response.config);
            
            pushInfo(response);  //推消息
    
            // 特别的api
            switch (keyUrl) {
                // case "api/clerk/task/union/":
                //     return response.data;
                case "api/user/login":  //login登录  不在拦截器报错
                    return response.data;
                case "api/saas/user/login":  //saas登录  不在拦截器报错
                    return response.data;
                case 'api/user':
                    if(response.data.status == 800){
                        Vue.prototype.errorTip(response.data.message);
                    }
                    return response.data;
            }
    
            // 批量处理
            let status = parseInt(response.data.status);
            switch (status) {
                case 800:   //session过期
                    if(store.state.userInfo.id){  //如果还没手动退出
                        Vue.prototype.errorTip(response.data.message);
                        Vue.prototype.$func.logout();
                        router.push({name:'login'});
                    }
                case 900:
                    Vue.prototype.errorTip(response.data.message);
            }
            return response.data;
        },
        
        error => {
    
        }
        
    );
}


// WEBPACK FOOTER //
// ./src/control/interceptor.js